export default __webpack_public_path__ + "static/media/tabler_urgent.2b36099d.svg";